import { Status } from './enums/status.enum';

export function isActiveUser(status: string | null) {
  return (+status! as Status) === Status.Active;
}
